<script setup lang="ts">
import Header from './Header.vue'
import Footer from './Footer.vue'
</script>

<template>
  <div class="shell">
    <a href="#main" class="skip">Skip to main content</a>

    <Header />

    <main id="main" tabindex="-1">
      <slot />
    </main>

    <Footer />
  </div>
</template>

<style scoped>
.shell {
  min-height: 100svh;
  display: flex;
  flex-direction: column;
}
main {
  flex: 1;
  outline: none;
}

.skip {
  position: absolute;
  left: -9999px;
  z-index: 100;
}
.skip:focus {
  left: 1rem;
  top: 1rem;
  padding: 0.6rem 1rem;
  background: var(--c-accent);
  color: var(--c-accent-ink);
  border-radius: 3px;
}
</style>
